import type { QueryParameterConfig } from '../hooks';

// eslint-disable-next-line @typescript-eslint/naming-convention -- need to be renamed to not eslint error
export const NonNullableStringParameter = {
  decode(value?: Array<null | string> | null | string) {
    if (typeof value === 'string') {
      return value;
    }

    return undefined;
  },

  default: undefined,
  encode(value?: string) {
    return value;
  },
} satisfies QueryParameterConfig<string | undefined>;
